import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

import RequestAppliedOffersSkeleton from '../skeleton/request-applied-offers-skeleton';
import { renderAttachment } from '../../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    wideTd: {
        minWidth: `125px`,
        maxWidth: `300px`
    }
});

const TransportationAppliedOffers = ({ reloadOffers, reservationReqId }) => {
    const [transportationOffers, setTransportationOffers] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        setLoading(true);
        axios.get(`/api/transportationoffer?reservationReqId=${reservationReqId}`, { headers: headers })
            .then(res => {
                setTransportationOffers(res.data);
                setTimeout(() => setLoading(false), 750);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [reloadOffers]);

    return (
        loading ?
            <RequestAppliedOffersSkeleton />
            :
            transportationOffers.length > 0 ?
                <TableContainer>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>Offer Headline</TableCell>
                                <TableCell>More Details</TableCell>
                                <TableCell>Create Date</TableCell>
                                <TableCell>Cancellation Policy</TableCell>
                                <TableCell>Attachment</TableCell>
                                <TableCell>Notes</TableCell>
                                <TableCell>Created By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                transportationOffers ?
                                    transportationOffers.map((transportationOffer, index) => (
                                        <Row key={index} row={transportationOffer} />
                                    )) :
                                    null
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <>
                    You haven't applied any offers for this request.
                </>
    );
}

const Row = ({ row }) => {
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell className={classes.wideTd}>{row.offerHeadline}</TableCell>
                <TableCell>
                    <Link to={`/offer/transportation/${row.id}`}><OpenInNewOutlinedIcon /></Link>
                </TableCell>
                <TableCell component="th" scope="row" className={classes.wideTd}>
                    {row.createDate.replace('T', ' ').substring(0, 16)}
                </TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.cancellationPolicy}</TableCell>
                <TableCell className={classes.wideTd}>{renderAttachment(row.attachment)}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.notes}</TableCell>
                <TableCell className={classes.wideTd}>{row.createdBy}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Transportations
                            </Typography>
                            <Table size="small" aria-label="transportations">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>From City (Address)</TableCell>
                                        <TableCell>To City (Address)</TableCell>
                                        <TableCell>Route Date</TableCell>
                                        <TableCell>Moving Time</TableCell>
                                        <TableCell>VehicleType</TableCell>
                                        <TableCell>No. of Cars</TableCell>
                                        <TableCell>Price/car</TableCell>
                                        <TableCell>Contact Phone Number</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.reservationSupplierTransportationOfferRouteResources.map((transportationRow, index) => (
                                        <TableRow key={index}>
                                            <TableCell component="th" scope="row" className={classes.wideTd}>
                                                {transportationRow.fromCityName} ({transportationRow.fromAddress})
                                            </TableCell>
                                            <TableCell className={classes.wideTd}>{transportationRow.toCityName} ({transportationRow.toAddress})</TableCell>
                                            <TableCell className={classes.wideTd}>{transportationRow.routeDate.substring(0, 10)}</TableCell>
                                            <TableCell>{transportationRow.movingTime.substring(0, 5)}</TableCell>
                                            <TableCell>{transportationRow.vehicleType}</TableCell>
                                            <TableCell>{transportationRow.noofCars}</TableCell>
                                            <TableCell>{transportationRow.carPrice}</TableCell>
                                            <TableCell>{transportationRow.contactPhoneNumber}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}


export default TransportationAppliedOffers;